import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function SolutionSection() {
  return <section className="bg-[#0F2E23] py-4 md:py-5 px-3 relative border-b border-[#1F3D2B]" data-id="element-194">
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-195">
        <div className="inline-block bg-[#071A14] border border-[#D4A843] text-[#D4A843] font-black px-3 py-1 rounded-full mb-2 uppercase tracking-widest text-[10px] md:text-xs shadow-sm" data-id="element-196">
          💡 SOLUCIÓN
        </div>

        <h2 className="text-xl md:text-3xl font-black text-[#D4A843] mb-2 uppercase tracking-tighter leading-tight" data-id="element-197">
          🔥 KIT COMPLETO EDUCACIÓN AMBIENTAL RURAL APLICADA
        </h2>

        <p className="text-sm md:text-base text-[#BFC9C5] font-bold mb-3 max-w-xl mx-auto leading-snug" data-id="element-198">
          Un sistema completo para dejar de pensar tus clases y empezar a
          ejecutarlas con seguridad.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 max-w-2xl mx-auto mb-3 text-left" data-id="element-199">
          {['6 tomos completos (480 páginas)', 'Contenido ambiental aplicado al campo', 'Actividades y proyectos listos', 'Evaluaciones completas', 'Sistema estructurado'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-[#071A14] border border-[#1F3D2B] p-2 rounded" data-id="element-200">
              <CheckCircle2Icon className="w-4 h-4 text-[#74C69D] flex-shrink-0" strokeWidth={3} data-id="element-201" />
              <span className="text-[#74C69D] font-bold text-xs md:text-sm leading-tight" data-id="element-202">
                {item}
              </span>
            </div>)}
        </div>

        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#D4A843]/40 to-transparent my-3" data-id="element-203"></div>

        <div className="flex flex-wrap justify-center gap-1.5 mb-3 max-w-2xl mx-auto" data-id="element-204">
          {['🌱 Problemáticas ambientales rurales', '🌿 Producción sustentable', '♻️ Cuidado del entorno', '🌾 Proyectos ambientales escolares', '🌎 Educación ambiental aplicada'].map((tag, i) => <span key={i} className="bg-[#102A1F] text-[#BFC9C5] text-[10px] md:text-xs font-bold px-2 py-1 rounded border border-[#1F3D2B]" data-id="element-205">
              {tag}
            </span>)}
        </div>

        <div className="bg-[#071A14] rounded p-2 inline-block w-full max-w-lg border border-[#1F3D2B]" data-id="element-206">
          <p className="text-[#D4A843] font-black text-sm md:text-base uppercase" data-id="element-207">
            👉 Todo organizado para que solo tengas que enseñar.
          </p>
        </div>
      </div>
    </section>;
}